(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adl-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProduct(root) {
      var opts = root.querySelectorAll('.adl-product__formula-opt:not([data-adl-size-opt])');
      var swaps = root.querySelectorAll('.adl-swap');
      if (!opts.length) return;
      var sizeRow = root.querySelector('[data-adl-size-row]');
      var sizeOpts = root.querySelectorAll('[data-adl-size-opt]');
      var tbyb = root.querySelector('[data-adl-tbyb]');
      var curIdx = (function () {
        var sel = root.querySelector('.adl-product__formula-opt.is-selected:not([data-adl-size-opt])');
        return sel ? sel.getAttribute('data-idx') : '0';
      })();
      var curSize = 'full';

      function isAll(idx) {
        var b = root.querySelector('.adl-product__formula-opt[data-idx="' + idx + '"]');
        return !!(b && b.hasAttribute('data-alltypes'));
      }
      function effectiveIdx() { return (isAll(curIdx) && curSize === 'mini') ? 'mini' : curIdx; }

      // Move Try Before You Buy into the active kit's buttons: Add to Bag → TBYB → Checkout Now.
      function positionTbyb(eff) {
        if (!tbyb) return;
        var swap = root.querySelector('.adl-product__atc .adl-swap[data-idx="' + eff + '"]');
        var addBtn = swap && swap.querySelector('button[name="add"]');
        if (!addBtn) return;
        var co = swap.querySelector('.adl-product__checkout');
        if (co) { co.insertAdjacentElement('beforebegin', tbyb); }
        else { addBtn.insertAdjacentElement('afterend', tbyb); }
        tbyb.hidden = false;
      }

      // Point the TryNow SDK at the selected product (same recipe as the PDP's
      // recalculate-try-now-state handler). Eligibility still follows the product's
      // own tags, so TryNow's visibility rules stay in charge.
      function retargetTryNow(eff) {
        if (!tbyb || !window.trynow || !window.trynow.product) return;
        var swap = root.querySelector('.adl-product__atc .adl-swap[data-idx="' + eff + '"]');
        var handle = swap && swap.getAttribute('data-handle');
        if (!handle) return;
        fetch('/products/' + handle + '.json')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var productData = {
              id: data.product.id,
              tags: (data.product.tags || '').split(', '),
              available: true,
              requires_selling_plan: false,
              selling_plan_groups: [],
              variants: data.product.variants.map(function (v) {
                return {
                  available: true,
                  id: v.id,
                  requires_selling_plan: false,
                  selling_plan_allocations: [
                    { price_adjustments: [], price: 0, compare_at_price: 0, per_delivery_price: 0, selling_plan_id: 6240010470, selling_plan_group_id: '' }
                  ]
                };
              })
            };
            try {
              if (window.trynow.reset) window.trynow.reset();
              window.trynow.components.ctaButton.setProduct(productData);
              window.trynow.components.ctaButton.setSelectedVariantId(productData.variants[0].id);
              window.trynow.product.recalculateCtaButtonState(productData);
            } catch (e) {}
          })
          .catch(function () {});
      }

      function apply() {
        var eff = effectiveIdx();
        for (var s = 0; s < swaps.length; s++) {
          swaps[s].hidden = (swaps[s].getAttribute('data-idx') !== eff);
        }
        opts.forEach(function (b) {
          var on = b.getAttribute('data-idx') === curIdx;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        sizeOpts.forEach(function (b) {
          var on = b.getAttribute('data-size') === curSize;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (sizeRow) sizeRow.hidden = !isAll(curIdx);
        positionTbyb(eff);
        retargetTryNow(eff);
      }

      opts.forEach(function (b) {
        b.addEventListener('click', function () {
          curIdx = b.getAttribute('data-idx');
          curSize = 'full'; // returning to a hair type always starts at Full Size
          apply();
        });
      });
      sizeOpts.forEach(function (b) {
        b.addEventListener('click', function () {
          curSize = b.getAttribute('data-size');
          apply();
        });
      });

      // "Checkout Now": empty the cart, add just this kit, go straight to checkout.
      var checkoutBtns = root.querySelectorAll('.adl-product__checkout');
      checkoutBtns.forEach(function (b) {
        // Move it directly below Add to Bag (above the Healthier Hair Promise note,
        // which the shared ATC snippet renders right after the submit button).
        var swap = b.closest('.adl-swap');
        var addBtn = swap && swap.querySelector('button[name="add"]');
        if (addBtn) { addBtn.insertAdjacentElement('afterend', b); }
        b.addEventListener('click', function () {
          var id = b.getAttribute('data-variant-id');
          if (!id || b.classList.contains('is-loading')) return;
          b.classList.add('is-loading');
          fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
              });
            })
            .then(function (res) {
              if (!res.ok) throw new Error('add failed');
              window.location.href = '/checkout';
            })
            .catch(function () {
              // fall back to the cart permalink (adds the item + routes to checkout)
              window.location.href = '/cart/' + id + ':1';
            });
        });
      });

      // initial placement (after checkout buttons are in position); TryNow SDK loads async
      positionTbyb(effectiveIdx());
      var tnTries = 0;
      var tnPoll = setInterval(function () {
        if (window.trynow && window.trynow.product) { clearInterval(tnPoll); retargetTryNow(effectiveIdx()); }
        else if (++tnTries > 40) { clearInterval(tnPoll); }
      }, 250);
    }
    function initAll() { document.querySelectorAll('[data-adl-product]').forEach(initProduct); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adl-producttabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      var tracks = Array.prototype.slice.call(root.querySelectorAll('[data-adl-track]'));
      if (!tracks.length) return;
      var lead = tracks[0];
      var n = lead.children.length;
      if (!n) return;
      var prev = root.querySelector('[data-adl-prev]');
      var next = root.querySelector('[data-adl-next]');
      var dots = root.querySelectorAll('[data-adl-dot]');
      var current = root.querySelector('[data-adl-current]');
      var counter = root.querySelector('.adl-gal__counter');

      // Force integer panel widths. At fractional container widths the panels are
      // fractional (50% each), so the next slide's image starts exactly on the panel's
      // fractional clip edge and antialiasing bleeds a sub-pixel sliver of it into view —
      // even at rest. Shrink the grid by up to 2px so both panels land on whole pixels.
      function sizeIntegers() {
        root.style.maxWidth = '';
        var w = root.getBoundingClientRect().width;
        var cs = getComputedStyle(root);
        var gap = parseFloat(cs.columnGap) || 0;
        var twoCol = cs.gridTemplateColumns.split(' ').length === 2;
        var target = twoCol ? gap + 2 * Math.floor((w - gap) / 2) : Math.floor(w);
        if (target > 0 && target < w) root.style.maxWidth = target + 'px';
      }
      sizeIntegers();

      // Exact cell pitch. clientWidth rounds to an integer, but the real cell width is
      // fractional at odd viewport widths (panels are 50% of a fractional container) —
      // rounding parked the track up to 0.5px off, exposing a sliver of the next slide
      // at the panel edge. Rect math keeps sub-pixel precision.
      function step() {
        var c = lead.children;
        if (c.length > 1) {
          var d = c[1].getBoundingClientRect().left - c[0].getBoundingClientRect().left;
          if (d > 1) return d;
        }
        return lead.getBoundingClientRect().width || 1;
      }
      function index() { return Math.round(lead.scrollLeft / step()); }
      function updateUI() {
        var i = index();
        dots.forEach(function (d) { d.classList.toggle('is-active', parseInt(d.getAttribute('data-adl-dot'), 10) === i); });
        if (current) current.textContent = String(i + 1);
        if (counter) {
          var rc = root.querySelectorAll('.adl-gal__rcell')[i];
          if (rc) { var c = rc.getAttribute('data-bg'); if (c) counter.style.backgroundColor = c; }
        }
        if (prev) { if (lead.scrollLeft <= 1) { prev.setAttribute('hidden', ''); } else { prev.removeAttribute('hidden'); } }
        if (next) { if (lead.scrollLeft >= lead.scrollWidth - lead.clientWidth - 1) { next.setAttribute('hidden', ''); } else { next.removeAttribute('hidden'); } }
      }

      // ---- lockstep sync ----
      // The track the user is gesturing on is the "active" one; the other follows pixel-for-pixel.
      // Followers must have scroll-snap disabled while following, otherwise every programmatic
      // scrollLeft write gets snapped to a whole slide and they only visibly move at gesture end.
      var active = null, settleTimer = null, anim = null, held = false;

      function setSnap(t, on) { t.classList.toggle('no-snap', !on); }
      function syncFrom(t) {
        var sl = t.scrollLeft;
        tracks.forEach(function (o) {
          if (o !== t && Math.abs(o.scrollLeft - sl) > 0.5) { setSnap(o, false); o.scrollLeft = sl; }
        });
      }
      function stopAnim() { if (anim) { cancelAnimationFrame(anim); anim = null; } }
      function settle() {
        // don't settle while a finger/mouse is still down — re-enabling snap mid-gesture
        // would snap the follower back to a whole slide
        if (held || !active) return;
        var sl = active.scrollLeft;
        tracks.forEach(function (o) { if (o !== active) o.scrollLeft = sl; setSnap(o, true); });
        active = null;
        updateUI();
      }
      function scheduleSettle() { clearTimeout(settleTimer); settleTimer = setTimeout(settle, 120); }

      tracks.forEach(function (t) {
        ['touchstart', 'pointerdown'].forEach(function (ev) {
          t.addEventListener(ev, function () { stopAnim(); active = t; held = true; }, { passive: true });
        });
        t.addEventListener('wheel', function () { stopAnim(); if (!held) active = t; }, { passive: true });
        t.addEventListener('scroll', function () {
          if (anim) return;                   // arrow animation drives all tracks itself
          if (active && t !== active) return; // echo from a follower we just moved
          if (!active) active = t;
          syncFrom(t);
          updateUI();
          scheduleSettle();
        }, { passive: true });
      });
      ['touchend', 'touchcancel', 'pointerup', 'pointercancel'].forEach(function (ev) {
        window.addEventListener(ev, function () { if (held) { held = false; scheduleSettle(); } }, { passive: true });
      });

      // arrows/dots: short fast ease-out slide, driving BOTH tracks' own scrollLeft in parallel
      // (each square only ever slides its own content — no bleed). Native smooth-scroll is
      // disabled on this theme, so the animation is rAF-driven.
      function animateTo(target) {
        stopAnim();
        active = null;
        var starts = tracks.map(function (t) { return t.scrollLeft; });
        tracks.forEach(function (t) { setSnap(t, false); });
        var t0 = null, duration = 240;
        function frame(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / duration);
          var e = 1 - Math.pow(1 - p, 3); // ease-out cubic
          tracks.forEach(function (t, i) { t.scrollLeft = starts[i] + (target - starts[i]) * e; });
          updateUI();
          if (p < 1) { anim = requestAnimationFrame(frame); }
          else {
            anim = null;
            tracks.forEach(function (t) { t.scrollLeft = target; setSnap(t, true); });
            updateUI();
          }
        }
        anim = requestAnimationFrame(frame);
      }
      var pendingIndex = null; // animation target, so rapid clicks chain correctly
      function goToIndex(i) { i = Math.max(0, Math.min(n - 1, i)); pendingIndex = i; animateTo(i * step()); }
      function baseIndex() { return anim && pendingIndex !== null ? pendingIndex : index(); }
      if (prev) prev.addEventListener('click', function () { goToIndex(baseIndex() - 1); });
      if (next) next.addEventListener('click', function () { goToIndex(baseIndex() + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { goToIndex(parseInt(d.getAttribute('data-adl-dot'), 10)); }); });

      // pointer drag-to-swipe (desktop mouse) on either track
      tracks.forEach(function (t) {
        var down = false, startX = 0, startScroll = 0;
        t.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; down = true; startX = e.clientX; startScroll = t.scrollLeft; t.classList.add('is-dragging'); });
        t.addEventListener('pointermove', function (e) { if (down) t.scrollLeft = startScroll - (e.clientX - startX); });
        function endDrag() { if (!down) return; down = false; t.classList.remove('is-dragging'); t.scrollLeft = Math.round(t.scrollLeft / step()) * step(); }
        t.addEventListener('pointerup', endDrag);
        t.addEventListener('pointercancel', endDrag);
        t.addEventListener('pointerleave', endDrag);
      });

      // linked left cells: a drag that ends on the link must not navigate
      var linkDownAt = null;
      root.addEventListener('pointerdown', function (e) { linkDownAt = { x: e.clientX, y: e.clientY }; }, true);
      Array.prototype.forEach.call(root.querySelectorAll('[data-adl-cell-link]'), function (a) {
        a.addEventListener('click', function (e) {
          if (linkDownAt && (Math.abs(e.clientX - linkDownAt.x) > 8 || Math.abs(e.clientY - linkDownAt.y) > 8)) { e.preventDefault(); }
        });
      });

      window.addEventListener('resize', function () {
        var i = index();          // keep the current slide while re-sizing
        sizeIntegers();
        tracks.forEach(function (t) { t.scrollLeft = i * step(); });
        updateUI();
      });
      updateUI();
    }
    function initAll() { document.querySelectorAll('[data-adl-gallery]').forEach(initGallery); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adl-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      var track = root.querySelector('[data-adl-track]');
      if (!track) return;
      var prev = root.querySelector('[data-adl-prev]');
      var next = root.querySelector('[data-adl-next]');
      var dots = root.querySelectorAll('[data-adl-dot]');
      var originals = Array.prototype.slice.call(track.children);
      var n = originals.length;
      if (!n) return;

      // Triple the set for seamless looping: [copy][originals][copy]
      var before = document.createDocumentFragment(), after = document.createDocumentFragment();
      originals.forEach(function (c) { var a = c.cloneNode(true); a.setAttribute('aria-hidden', 'true'); before.appendChild(a); });
      originals.forEach(function (c) { var b = c.cloneNode(true); b.setAttribute('aria-hidden', 'true'); after.appendChild(b); });
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);

      function step() { return track.children[1].offsetLeft - track.children[0].offsetLeft; }
      function setWidth() { return n * step(); }
      function recenter() {
        var sw = setWidth(); if (sw <= 0) return;
        if (track.scrollLeft < sw - 1) { track.scrollLeft += sw; }
        else if (track.scrollLeft >= 2 * sw - 1) { track.scrollLeft -= sw; }
      }
      function realIndex() { var i = Math.round(track.scrollLeft / step()); return ((i % n) + n) % n; }
      function updateDots() { var i = realIndex(); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); }

      var settle;
      track.addEventListener('scroll', function () {
        updateDots();
        clearTimeout(settle);
        settle = setTimeout(recenter, 120);
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { track.scrollTo({ left: setWidth() + k * step(), behavior: 'smooth' }); }); });

      // pointer drag (desktop)
      var down = false, startX = 0, startScroll = 0;
      track.addEventListener('pointerdown', function (e) { down = true; startX = e.clientX; startScroll = track.scrollLeft; track.classList.add('is-dragging'); });
      track.addEventListener('pointermove', function (e) { if (down) track.scrollLeft = startScroll - (e.clientX - startX); });
      function endDrag() { if (!down) return; down = false; track.classList.remove('is-dragging'); track.scrollTo({ left: Math.round(track.scrollLeft / step()) * step(), behavior: 'smooth' }); }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      // start on the middle (original) set
      requestAnimationFrame(function () { track.scrollLeft = setWidth(); updateDots(); });
      window.addEventListener('resize', function () { updateDots(); });
    }
    function initAll() { document.querySelectorAll('[data-adl-reviews]').forEach(initReviews); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adl-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initUGC(root) {
      var vids = Array.prototype.slice.call(root.querySelectorAll('[data-adl-video]'));
      if (!vids.length) return;
      var mqMobile = window.matchMedia('(max-width: 767px)');
      var started = false, active = -1, done = false;
      var ratios = {};

      function btnOf(v) { return v.parentNode.querySelector('[data-adl-play]'); }
      function showBtn(v, show) { var b = btnOf(v); if (b) { if (show) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); } } }
      function playIndex(i) {
        active = i;
        vids.forEach(function (v, idx) {
          if (idx === i) { v.muted = true; var p = v.play(); if (p && p.catch) { p.catch(function () { showBtn(v, true); }); } }
          else if (!v.paused) { v.pause(); }
        });
      }

      // On mobile the clips are a horizontal swipe carousel: the clip that is
      // predominantly in view plays (and loops); swiping to another pauses the
      // old one and autoplays the new. On desktop all clips are visible at once,
      // so we keep the original playlist chaining (clip finishes → next plays).
      vids.forEach(function (v, idx) {
        v.addEventListener('play', function () { showBtn(v, false); });
        v.addEventListener('pause', function () { if (!v.ended) showBtn(v, true); });
        v.addEventListener('ended', function () {
          if (mqMobile.matches) { return; } // looped clips don't fire 'ended'; guard anyway
          showBtn(v, true);
          if (idx === active && !done) {
            if (active < vids.length - 1) { playIndex(active + 1); }
            else { done = true; }
          }
        });
        var b = btnOf(v);
        if (b) b.addEventListener('click', function () { started = true; done = false; playIndex(idx); });
      });

      function syncLoop() { vids.forEach(function (v) { v.loop = mqMobile.matches; }); }
      syncLoop();
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', syncLoop);

      function predominant() {
        var best = -1, bestR = 0;
        vids.forEach(function (v, i) { var r = ratios[i] || 0; if (r > bestR) { bestR = r; best = i; } });
        return { idx: best, ratio: bestR };
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ratios[vids.indexOf(e.target)] = e.intersectionRatio; });

        if (mqMobile.matches) {
          var p = predominant();
          if (p.idx !== -1 && p.ratio >= 0.6) {
            if (p.idx !== active) { started = true; playIndex(p.idx); }
          } else if (p.ratio < 0.2 && active !== -1 && !vids[active].paused) {
            vids[active].pause();
          }
          return;
        }

        // desktop: autoplay the first when in view, then chain on 'ended'
        entries.forEach(function (e) {
          var idx = vids.indexOf(e.target);
          if (idx === 0 && !started && e.intersectionRatio >= 0.75) { started = true; playIndex(0); }
          if (started && !done && idx === active) {
            if (e.intersectionRatio === 0) { e.target.pause(); }
            else if (e.target.paused && !e.target.ended) { var pr = e.target.play(); if (pr && pr.catch) pr.catch(function () {}); }
          }
        });
      }, { threshold: [0, 0.2, 0.4, 0.6, 0.75, 0.9, 1] });
      vids.forEach(function (v) { io.observe(v); });
    }
    function initAll() { document.querySelectorAll('[data-adl-ugc]').forEach(initUGC); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adl-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideo(section) {
      var frame = section.querySelector('[data-adl-vimeo]');
      if (!frame) return;
      function post(method) {
        try { frame.contentWindow.postMessage(JSON.stringify({ method: method }), 'https://player.vimeo.com'); } catch (e) {}
      }
      var playing = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.intersectionRatio >= 0.9) { if (!playing) { playing = true; post('play'); } }
          else if (e.intersectionRatio === 0) { if (playing) { playing = false; post('pause'); } }
        });
      }, { threshold: [0, 0.9, 1] });
      io.observe(frame);
    }
    function initAll() { document.querySelectorAll('[data-adl-video-section]').forEach(initVideo); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enw-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initUGC(root) {
      if (root.dataset.enwUgcInit) return;
      root.dataset.enwUgcInit = '1';
      var track = root.querySelector('[data-enw-ugc-track]');
      if (!track) return;
      var previousButton = root.querySelector('[data-enw-previous]');
      var nextButton = root.querySelector('[data-enw-next]');
      var vids = Array.prototype.slice.call(root.querySelectorAll('[data-enw-video]'));
      var setSize = parseInt(root.getAttribute('data-enw-set-size'), 10) || 0;
      var sequenceActive = false;
      var loopLock = false;

      function items() { return track.children; }
      function pitch() {
        var first = track.firstElementChild;
        if (!first) return 1;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      function setWidth() { return setSize > 0 ? setSize * pitch() : track.clientWidth; }
      function centerOf(el) { return el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2; }
      function nearest() {
        var c = track.scrollLeft + track.clientWidth / 2;
        var els = items(), best = els[0], bd = Infinity;
        for (var i = 0; i < els.length; i++) {
          var ic = els[i].offsetLeft + els[i].offsetWidth / 2;
          var d = Math.abs(ic - c);
          if (d < bd) { bd = d; best = els[i]; }
        }
        return best;
      }
      function scrollToEl(el, smooth) {
        if (!el) return;
        track.scrollTo({ left: centerOf(el), behavior: smooth ? 'smooth' : 'auto' });
      }

      // ---- video helpers ----
      function showButton(b) { if (b) b.removeAttribute('hidden'); }
      function hideButton(b) { if (b) b.setAttribute('hidden', ''); }
      function showPoster(v) { var p = v.parentNode.querySelector('[data-enw-poster]'); if (p) p.removeAttribute('hidden'); }
      function hidePoster(v) { var p = v.parentNode.querySelector('[data-enw-poster]'); if (p) p.setAttribute('hidden', ''); }

      function resetVideo(v) {
        var btn = v.parentNode.querySelector('[data-enw-play]');
        v.dataset.enwResetting = '1';
        v.dataset.enwFinishing = '';
        v.pause();
        try { v.currentTime = 0; } catch (e) {}
        v.controls = false;
        v.load();
        showPoster(v);
        showButton(btn);
        setTimeout(function () { v.dataset.enwResetting = ''; }, 0);
      }
      function stopOthers(exceptItem) {
        vids.forEach(function (v) { if (v.closest('.enw-ugc__item') !== exceptItem) resetVideo(v); });
      }
      function cancelSequence() { sequenceActive = false; }

      function playItem(item) {
        if (!item) return;
        var v = item.querySelector('[data-enw-video]');
        if (!v) return;
        sequenceActive = true;
        stopOthers(item);
        v.muted = false; v.defaultMuted = false; v.volume = 1;
        var p = v.play();
        if (p && p.catch) p.catch(function () { cancelSequence(); showButton(item.querySelector('[data-enw-play]')); });
      }

      // ---- seamless loop: jump by one set-width when near an edge ----
      function maybeLoop() {
        if (loopLock) return;
        var sw = setWidth();
        var max = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft < sw * 0.5) {
          track.scrollLeft += sw;
        } else if (track.scrollLeft > max - sw * 0.5) {
          track.scrollLeft -= sw;
        }
      }
      var loopTimer = null;
      track.addEventListener('scroll', function () {
        clearTimeout(loopTimer);
        loopTimer = setTimeout(maybeLoop, 140);
      }, { passive: true });

      // ---- initial center (middle set) ----
      function center() {
        var els = items();
        if (!els.length || els[0].getBoundingClientRect().width === 0) { requestAnimationFrame(center); return; }
        loopLock = true;
        scrollToEl(els[Math.floor(els.length / 2)], false);
        setTimeout(function () { loopLock = false; }, 50);
      }
      center();
      window.addEventListener('load', center);
      var resizeTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { scrollToEl(nearest(), false); }, 150);
      });

      // ---- arrows ----
      function move(direction) {
        cancelSequence();
        stopOthers(null);
        var els = items();
        var cur = nearest();
        var idx = Array.prototype.indexOf.call(els, cur);
        var target = els[idx + direction];
        if (!target) { maybeLoop(); target = items()[Array.prototype.indexOf.call(items(), nearest()) + direction]; }
        scrollToEl(target, true);
      }
      if (previousButton) previousButton.addEventListener('click', function () { move(-1); });
      if (nextButton) nextButton.addEventListener('click', function () { move(1); });

      // ---- advance to next clip and play it (finish -> advance chain) ----
      function advance() {
        var els = items();
        var idx = Array.prototype.indexOf.call(els, nearest());
        var target = els[idx + 1];
        if (!target) { maybeLoop(); els = items(); idx = Array.prototype.indexOf.call(els, nearest()); target = els[idx + 1]; }
        if (!target) return;
        scrollToEl(target, true);
        var tries = 0;
        (function waitCentered() {
          if (Math.abs(centerOf(target) - track.scrollLeft) <= 4 || tries > 40) {
            if (sequenceActive) playItem(target);
            return;
          }
          tries += 1;
          setTimeout(waitCentered, 40);
        })();
      }

      function finishNative(v) {
        if (v.dataset.enwFinishing === '1') return;
        v.dataset.enwFinishing = '1';
        var wasSequence = sequenceActive;
        resetVideo(v);
        if (wasSequence) { sequenceActive = true; advance(); }
      }

      // ---- per-video wiring ----
      vids.forEach(function (v) {
        var btn = v.parentNode.querySelector('[data-enw-play]');
        v.dataset.enwLabel = v.getAttribute('aria-label') || 'Customer New Wash video';
        v.controls = false;
        showPoster(v);

        v.addEventListener('play', function () {
          v.dataset.enwFinishing = '';
          var item = v.closest('.enw-ugc__item');
          stopOthers(item);
          v.controls = true;
          hidePoster(v);
          hideButton(btn);
        });
        v.addEventListener('ended', function () { finishNative(v); });
        v.addEventListener('timeupdate', function () {
          if (Number.isFinite(v.duration) && v.duration > 0 && v.currentTime >= v.duration - 0.08) finishNative(v);
        });
        v.addEventListener('pause', function () {
          if (v.dataset.enwResetting === '1') return;
          setTimeout(function () {
            if (v.dataset.enwResetting === '1' || !v.paused) return;
            if (Number.isFinite(v.duration) && v.duration > 0 && v.currentTime >= v.duration - 0.08) { finishNative(v); return; }
            cancelSequence(); resetVideo(v);
          }, 0);
        });
        v.addEventListener('click', function (e) {
          if (v.paused) return;
          var controlsHeight = window.innerWidth <= 767 ? 72 : 64;
          if (v.controls && e.offsetY >= v.clientHeight - controlsHeight) return;
          e.preventDefault(); cancelSequence(); resetVideo(v);
        });
        v.addEventListener('keydown', function (e) {
          if (!v.paused && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); cancelSequence(); resetVideo(v); }
        });
        if (btn) btn.addEventListener('click', function () {
          var item = v.closest('.enw-ugc__item');
          if (item !== nearest()) scrollToEl(item, true);
          playItem(item);
        });
      });
    }

    function initAll() { document.querySelectorAll('[data-enw-ugc]').forEach(initUGC); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enw-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function post(frame, method) {
      if (!frame.contentWindow) return;
      try { frame.contentWindow.postMessage(JSON.stringify({ method: method }), 'https://player.vimeo.com'); } catch (e) {}
    }
    function init(frame) {
      if (frame.dataset.enwVidInit) return;
      frame.dataset.enwVidInit = '1';
      if (!('IntersectionObserver' in window)) { post(frame, 'play'); return; }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.99) {
            post(frame, 'play');
          } else {
            post(frame, 'pause');
          }
        });
      }, { threshold: [0, 0.99, 1] });
      observer.observe(frame);
    }
    document.querySelectorAll('[data-enw-video-frame]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw101-beforeafter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBA(slider) {
      var before = slider.querySelector('[data-ba-before]');
      var handle = slider.querySelector('[data-ba-handle]');
      if (!before || !handle) return;
      var dragging = false;
      function setPos(clientX) {
        var rect = slider.getBoundingClientRect();
        var pos = ((clientX - rect.left) / rect.width) * 100;
        pos = Math.max(0, Math.min(100, pos));
        before.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
        handle.style.left = pos + '%';
      }
      slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
      slider.addEventListener('pointerdown', function (e) {
        if (window.matchMedia('(max-width: 767px)').matches) return; // mobile: static, no dragging
        if (e.pointerType === 'touch') return; // let touch scroll the row; drag is mouse/pen
        dragging = true;
        e.preventDefault();
        try { slider.setPointerCapture(e.pointerId); } catch (err) {}
        setPos(e.clientX);
      });
      slider.addEventListener('pointermove', function (e) { if (dragging) { e.preventDefault(); setPos(e.clientX); } });
      function stop() { dragging = false; }
      slider.addEventListener('pointerup', stop);
      slider.addEventListener('pointercancel', stop);
    }
    function initAll() { document.querySelectorAll('.nw101-ba__slider[data-ba]').forEach(initBA); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw101-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var items = document.querySelectorAll('.nw101-faqacc__item');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw101-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var section = document.querySelector('.nw101-wi');
      if (!section) return;
      var track = section.querySelector('[data-wi-track]');
      var dots = section.querySelectorAll('[data-wi-dot]');
      var slides = section.querySelectorAll('.nw101-wi__slide');

      // Active dot on scroll
      function update() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }
      track.addEventListener('scroll', update, { passive: true });
      dots.forEach(function (d, n) {
        d.addEventListener('click', function () { track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' }); });
      });

      // Pointer drag-to-swipe (desktop)
      var down = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) { down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft; track.classList.add('is-dragging'); });
      track.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = startScroll - dx; });
      function end() {
        if (!down) return; down = false; track.classList.remove('is-dragging');
        track.scrollTo({ left: Math.round(track.scrollLeft / track.clientWidth) * track.clientWidth, behavior: 'smooth' });
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('pointerleave', end);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw101-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MATRIX = {
      fine:    { none: 'original', dry: 'original', oily: 'deepclean', sensitive: 'ff' },
      medium:  { none: 'original', dry: 'rich',     oily: 'deepclean', sensitive: 'ff' },
      coarse:  { none: 'rich',     dry: 'rich',     oily: 'original',  sensitive: 'ff' },
      damaged: { none: 'rich',     dry: 'rich',     oily: 'original',  sensitive: 'ff' }
    };
    function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

    function checkoutNow(btn) {
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.disabled) return;
      btn.disabled = true; btn.classList.add('is-loading');
      var base = root();
      fetch(base + 'cart/clear.js', { method: 'POST' })
        .then(function () {
          var fd = new FormData();
          fd.append('id', id); fd.append('quantity', '1');
          return fetch(base + 'cart/add.js', { method: 'POST', body: fd });
        })
        .then(function () { window.location.href = base + 'checkout'; })
        .catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    }

    function init() {
      document.querySelectorAll('.nw101-prod').forEach(function (sect) {
        if (sect.dataset.nw101Bound) return;
        sect.dataset.nw101Bound = '1';
        function keyFromSelectors() {
          var t = (sect.querySelector('input[name="nw101-type"]:checked') || {}).value || 'fine';
          var c = (sect.querySelector('input[name="nw101-concern"]:checked') || {}).value || 'none';
          return (MATRIX[t] || {})[c] || 'original';
        }
        function apply() {
          var key = keyFromSelectors();
          sect.querySelectorAll('.nw101-swap[data-key]').forEach(function (el) {
            el.classList.toggle('is-active', el.getAttribute('data-key') === key);
          });
        }
        sect.querySelectorAll('input[name="nw101-type"], input[name="nw101-concern"]').forEach(function (r) {
          r.addEventListener('change', apply);
        });
        sect.querySelectorAll('.nw101-prod__checkout').forEach(function (btn) {
          btn.addEventListener('click', function () { checkoutNow(btn); });
        });
        apply();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw101-reasons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(group) {
      var items = group.querySelectorAll('details.nw101-acc__item');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
        });
      });
    }
    document.querySelectorAll('.nw101-acc--numbered').forEach(bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pwlp-ba-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBA(slider) {
      var before = slider.querySelector('[data-pwlp-ba-before]');
      var handle = slider.querySelector('[data-pwlp-ba-handle]');
      if (!before || !handle) return;
      var dragging = false;
      function setPos(clientX) {
        var rect = slider.getBoundingClientRect();
        var pos = ((clientX - rect.left) / rect.width) * 100;
        pos = Math.max(0, Math.min(100, pos));
        before.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
        handle.style.left = pos + '%';
      }
      slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
      slider.addEventListener('pointerdown', function (e) {
        if (window.matchMedia('(max-width: 767px)').matches) return; // mobile: static, no dragging
        dragging = true;
        e.preventDefault();
        try { slider.setPointerCapture(e.pointerId); } catch (err) {}
        setPos(e.clientX);
      });
      slider.addEventListener('pointermove', function (e) { if (dragging) { e.preventDefault(); setPos(e.clientX); } });
      function stop() { dragging = false; }
      slider.addEventListener('pointerup', stop);
      slider.addEventListener('pointercancel', stop);
    }
    function initAll() { document.querySelectorAll('.pwlp-ba-grid__slider[data-pwlp-ba]').forEach(initBA); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pwlp-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProduct(root) {
      var addBtn = root.querySelector('.pwlp-product__atc button[name="add"]');
      var checkout = root.querySelector('.pwlp-product__checkout');
      var tbyb = root.querySelector('[data-pwlp-tbyb]');

      // Button order: Add to Bag → TBYB → Checkout Now, all above the
      // 21-Day Promise note (which the shared ATC snippet renders after the button).
      // The TBYB wrapper stays hidden here — it's only revealed once TryNow
      // confirms the product is eligible (see revealIfEligible), so an untagged
      // product renders nothing at all.
      if (addBtn && checkout) addBtn.insertAdjacentElement('afterend', checkout);
      if (addBtn && tbyb) {
        if (checkout) checkout.insertAdjacentElement('beforebegin', tbyb);
        else addBtn.insertAdjacentElement('afterend', tbyb);
      }

      // Reveal the wrapper only if the SDK rendered a real, visible CTA button.
      // Untagged / ineligible products leave the CTA at display:none, so the
      // wrapper stays hidden and nothing shows.
      function revealIfEligible() {
        if (!tbyb) return false;
        var cta = tbyb.querySelector('trynow-cta-button');
        var btn = cta && cta.querySelector('button, a, [role="button"]');
        // Check the CTA's OWN display, not rendered height: while the wrapper is
        // still hidden every descendant measures 0px, so a height test can never
        // flip true. The SDK sets the cta-button to display:none when the product
        // is ineligible/untagged, and leaves it visible when eligible.
        var visible = !!btn && getComputedStyle(cta).display !== 'none';
        tbyb.hidden = !visible;
        return visible;
      }

      // Prime the TryNow SDK with the product (same recipe as the Air Dry landing
      // and the PDP's recalculate-try-now-state handler) — without this the SDK
      // leaves its CTA display:none. Eligibility still follows the product's own
      // tags, so TryNow's visibility rules stay in charge.
      var handle = root.getAttribute('data-product-handle');
      function primeTryNow() {
        if (!tbyb || !handle || !window.trynow || !window.trynow.product) return;
        fetch('/products/' + handle + '.json')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var productData = {
              id: data.product.id,
              tags: (data.product.tags || '').split(', '),
              available: true,
              requires_selling_plan: false,
              selling_plan_groups: [],
              variants: data.product.variants.map(function (v) {
                return {
                  available: true,
                  id: v.id,
                  requires_selling_plan: false,
                  selling_plan_allocations: [
                    { price_adjustments: [], price: 0, compare_at_price: 0, per_delivery_price: 0, selling_plan_id: 6240010470, selling_plan_group_id: '' }
                  ]
                };
              })
            };
            try {
              window.trynow.components.ctaButton.setProduct(productData);
              window.trynow.components.ctaButton.setSelectedVariantId(productData.variants[0].id);
              window.trynow.product.recalculateCtaButtonState(productData);
            } catch (e) {}
            // The SDK updates the CTA asynchronously; poll briefly for the result.
            var rTries = 0;
            var rPoll = setInterval(function () {
              if (revealIfEligible() || ++rTries > 20) clearInterval(rPoll);
            }, 150);
          })
          .catch(function () {});
      }
      if (tbyb) {
        var tnTries = 0;
        var tnPoll = setInterval(function () {
          if (window.trynow && window.trynow.product) { clearInterval(tnPoll); primeTryNow(); }
          else if (++tnTries > 40) { clearInterval(tnPoll); }
        }, 250);
      }

      // "Checkout Now": empty the cart, add just this product, go straight to checkout.
      if (checkout) {
        checkout.addEventListener('click', function () {
          var id = checkout.getAttribute('data-variant-id');
          if (!id || checkout.classList.contains('is-loading')) return;
          checkout.classList.add('is-loading');
          fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(function () {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
              });
            })
            .then(function (res) {
              if (!res.ok) throw new Error('add failed');
              window.location.href = '/checkout';
            })
            .catch(function () {
              window.location.href = '/cart/' + id + ':1';
            });
        });
      }
    }
    function initAll() { document.querySelectorAll('[data-pwlp-product]').forEach(initProduct); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pwlp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      var track = root.querySelector('[data-pwlp-track]');
      if (!track) return;
      var prev = root.querySelector('[data-pwlp-prev]');
      var next = root.querySelector('[data-pwlp-next]');
      var dots = root.querySelectorAll('[data-pwlp-dot]');
      var originals = Array.prototype.slice.call(track.children);
      var n = originals.length;
      if (!n) return;

      // Triple the set for seamless looping: [copy][originals][copy]
      var before = document.createDocumentFragment(), after = document.createDocumentFragment();
      originals.forEach(function (c) { var a = c.cloneNode(true); a.setAttribute('aria-hidden', 'true'); before.appendChild(a); });
      originals.forEach(function (c) { var b = c.cloneNode(true); b.setAttribute('aria-hidden', 'true'); after.appendChild(b); });
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);

      // On mobile the grid stacks cards 2-high, so consecutive children can share
      // a column. rows() counts how many share the first column; step() is the
      // distance between adjacent columns; a "slide" is a column, not a card.
      function rows() {
        var x0 = track.children[0].offsetLeft, r = 1;
        for (var i = 1; i < track.children.length; i++) {
          if (track.children[i].offsetLeft === x0) r++; else break;
        }
        return r;
      }
      function step() {
        var x0 = track.children[0].offsetLeft;
        for (var i = 1; i < track.children.length; i++) {
          var d = track.children[i].offsetLeft - x0;
          if (d > 0) return d;
        }
        return 0;
      }
      function cols() { return Math.ceil(n / rows()); }
      function setWidth() { return cols() * step(); }

      function recenter() {
        var sw = setWidth(); if (sw <= 0) return;
        if (track.scrollLeft < sw - 1) { track.scrollLeft += sw; }
        else if (track.scrollLeft >= 2 * sw - 1) { track.scrollLeft -= sw; }
      }
      function realIndex() {
        var s = step(); if (!s) return 0;
        var c = cols();
        var i = Math.round(track.scrollLeft / s);
        return ((i % c) + c) % c;
      }
      function updateDots() {
        var i = realIndex();
        var perDot = Math.max(1, Math.round(cols() / dots.length));
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === Math.floor(i / perDot) % dots.length); });
      }

      var settle;
      track.addEventListener('scroll', function () {
        updateDots();
        clearTimeout(settle);
        settle = setTimeout(recenter, 120);
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () {
          var perDot = Math.max(1, Math.round(cols() / dots.length));
          track.scrollTo({ left: setWidth() + k * perDot * step(), behavior: 'smooth' });
        });
      });

      // pointer drag (desktop)
      var down = false, startX = 0, startScroll = 0;
      track.addEventListener('pointerdown', function (e) { down = true; startX = e.clientX; startScroll = track.scrollLeft; track.classList.add('is-dragging'); });
      track.addEventListener('pointermove', function (e) { if (down) track.scrollLeft = startScroll - (e.clientX - startX); });
      function endDrag() { if (!down) return; down = false; track.classList.remove('is-dragging'); track.scrollTo({ left: Math.round(track.scrollLeft / step()) * step(), behavior: 'smooth' }); }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      // start on the middle (original) set; re-anchor when the breakpoint flips
      function centerStart() { track.scrollLeft = setWidth(); updateDots(); }
      requestAnimationFrame(centerStart);
      var mq = window.matchMedia('(max-width: 767px)');
      if (mq.addEventListener) mq.addEventListener('change', function () { requestAnimationFrame(centerStart); });
      window.addEventListener('resize', function () { updateDots(); });
    }
    function initAll() { document.querySelectorAll('[data-pwlp-reviews]').forEach(initReviews); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pwlp-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideo(section) {
      var video = section.querySelector('[data-pwlp-native]');
      var play = section.querySelector('[data-pwlp-play]');
      if (!video) return;

      // Keep native controls off while the poster is showing so the browser
      // cannot place its own play overlay behind the custom button. Once the
      // user starts playback, native controls handle play/pause/audio.
      function showPlay(show) { if (play) { if (show) { play.removeAttribute('hidden'); } else { play.setAttribute('hidden', ''); } } }

      if (play) {
        play.addEventListener('click', function () {
          video.controls = true;
          var p = video.play();
          if (p && p.catch) p.catch(function () {
            video.controls = false;
            showPlay(true);
          });
        });
      }
      video.addEventListener('play', function () { showPlay(false); });
    }
    function initAll() { document.querySelectorAll('[data-pwlp-video-section]').forEach(initVideo); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  })();

  } catch(e) { console.error(e); }
})();
})();
